export const LOAD_CATEGORIES_QUERY = require('./loadCategoriesQuery.graphql');
export const LOAD_INDUSTRIES_QUERY = require('./loadIndustriesQuery.graphql');
export const LOAD_PREMIUM_PACKS = require('./loadPremiumPacksQuery.graphql');
export const LOAD_MY_CLASSIFIED_AD = require('./loadMyClassifiedAdQuery.graphql');
